import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { PartnersSelectionComponent } from './partners-selection.component';
import { PartnersSelectionDialogComponent } from './partners-dialog/partners-selection-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { ActionButtonModule, ListFilterModule, SvgIconModule } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxsModule } from '@ngxs/store';
import { PartnerListState } from '../../store/state/administration/partner';
import { DirectivesModule } from '../../common/directives/directives.module';
import { PipesModule } from '../../common';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    SvgIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    ListFilterModule,
    MatCheckboxModule,
    ActionButtonModule,
    MatDialogModule,
    RouterModule,
    NgxsModule.forFeature([PartnerListState]),
    TranslateModule.forChild({}),
    DirectivesModule,
    PipesModule,
  ],
  exports: [PartnersSelectionComponent, PartnersSelectionDialogComponent],
  declarations: [PartnersSelectionComponent, PartnersSelectionDialogComponent],
})
export class PartnersSelectionModule {}
